import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, isRef as _isRef, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5" }, "Количество талонов:", -1)

import { computed } from 'vue'
import {
  CitizenCategory,
  citizenCategoryName,
  citizenCategoryShorthand,
  ProductCategory,
  PRODUCT_CATEGORIES_INFO,
  ActualIssueProduct,
  MunicipalEntitiesService,
  AddActualIssueProductOpts,
  AppAuthService,
  Permissions,
} from '@prodcard/core'
import { useWatcherSavedRef } from '../../../../helpers'
import { useAuthPermissions } from '../../../../mixins'
import { VMunicipalEntitiesSelect } from '../../../../components'
import useVuelidate, { ErrorObject } from '@vuelidate/core'
import { minValue, helpers, required, integer } from '@vuelidate/validators'
import { mapValues, set, get, toArray } from 'lodash'

interface Props {
  municipalEntitiesService: MunicipalEntitiesService
  authService: AppAuthService
  actualIssueProduct?: ActualIssueProduct
  loading?: boolean
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ActualIssueProductForm',
  props: {
    municipalEntitiesService: {},
    authService: {},
    actualIssueProduct: {},
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["submit"],
  setup(__props: any, { emit }) {

const props = __props;





const { hasPermissions, currentMunicipalEntityId } = useAuthPermissions(props.authService)
const hasManage = computed(() => hasPermissions(Permissions.ACTUAL_ISSUE_PRODUCTS_MANAGE))
const hasMeManage = computed(() => hasPermissions(Permissions.ME_ACTUAL_ISSUE_PRODUCTS_MANAGE))

const currentTab = useWatcherSavedRef('actualProductCurrentTab', CitizenCategory.CH)

const actualIssueProductOpts = useWatcherSavedRef<AddActualIssueProductOpts>('actualIssueProduct', {
  dataEntryDate: new Date(),
  values: mapValues(CitizenCategory, () => ({})),
  municipalEntityId: !hasManage.value && hasMeManage.value ? currentMunicipalEntityId.value : '',
})

const rules = computed(() => ({
  municipalEntityId: {
    required: helpers.withMessage('Муниципальное образование не может быть пустым', required),
  },
  values: mapValues(CitizenCategory, () => {
    return mapValues(ProductCategory, () => ({
      couponsCount: {
        minValue: helpers.withMessage('Значение не может быть меньше 0', minValue(0)),
        integer: helpers.withMessage('Значение не может быть дробным', integer),
      },
    }))
  }),
}))

const validator = useVuelidate<AddActualIssueProductOpts>(rules, actualIssueProductOpts)

const getErrorMessages = (errors: ErrorObject[]) => {
  return errors.map((e: ErrorObject) => e.$message).join(', ')
}

const submit = async () => {
  const valid = await validator.value.$validate()

  if (valid) {
    actualIssueProductOpts.value.dataEntryDate = new Date()
    emit('submit', actualIssueProductOpts.value)
  } else {
    toArray(CitizenCategory).every(citizenCategory => {
      if (validator.value.values[citizenCategory]?.$invalid) {
        currentTab.value = citizenCategory
        return false
      }
      return true
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    "validate-on": "blur",
    onSubmit: _withModifiers(submit, ["prevent"]),
    disabled: _ctx.loading || _ctx.disabled
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                "model-value": `${_unref(actualIssueProductOpts).dataEntryDate.toLocaleDateString()} ${_unref(actualIssueProductOpts).dataEntryDate.toLocaleTimeString()}`,
                label: "Дата внесения данных",
                readonly: ""
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_unref(VMunicipalEntitiesSelect), {
                "model-value": _unref(actualIssueProductOpts).municipalEntityId ?? undefined,
                "municipal-entities-service": _ctx.municipalEntitiesService,
                "error-messages": getErrorMessages(_unref(validator).municipalEntityId.$errors),
                readonly: !hasManage.value && hasMeManage.value,
                label: "Муниципальное образование*",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = val => (_unref(actualIssueProductOpts).municipalEntityId = val || ''))
              }, null, 8, ["model-value", "municipal-entities-service", "error-messages", "readonly"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        justify: "center",
        class: "my-1"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CitizenCategory), (citizenCategory) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: citizenCategory,
              cols: "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: ($event: any) => (currentTab.value = citizenCategory),
                  variant: _unref(currentTab) === citizenCategory ? 'flat' : 'tonal',
                  size: "large",
                  ripple: false,
                  title: _unref(citizenCategoryName)(citizenCategory)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(citizenCategoryShorthand)(citizenCategory)), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "variant", "title"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _hoisted_1,
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_window, {
                modelValue: _unref(currentTab),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentTab) ? (currentTab).value = $event : null))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CitizenCategory), (citizenCategory) => {
                    return (_openBlock(), _createBlock(_component_v_window_item, {
                      key: citizenCategory,
                      value: citizenCategory,
                      class: "pt-5",
                      eager: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { justify: "center" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ProductCategory), (productCategory) => {
                              return (_openBlock(), _createBlock(_component_v_col, {
                                key: productCategory,
                                cols: "12",
                                sm: "6",
                                md: "4",
                                lg: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    "model-value": 
                    _unref(get)(_unref(actualIssueProductOpts), `values.${citizenCategory}.${productCategory}.couponsCount`) ||
                    undefined
                  ,
                                    placeholder: "0",
                                    label: _unref(PRODUCT_CATEGORIES_INFO)[productCategory].description,
                                    "error-messages": 
                    getErrorMessages(_unref(validator).values[citizenCategory][productCategory].couponsCount.$errors)
                  ,
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => (
                    _unref(set)(
                      _unref(actualIssueProductOpts),
                      `values.${citizenCategory}.${productCategory}.couponsCount`,
                      $event ? Number($event) : 0,
                    )
                  )
                                  }, null, 8, ["model-value", "label", "error-messages", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { justify: "end" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                type: "submit",
                color: "primary",
                loading: _ctx.loading,
                disabled: _ctx.disabled
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Сохранить ")
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onSubmit", "disabled"]))
}
}

})